<script lang="ts" setup>
import type { AccordionProps } from "./accordion.types";
import { useAccordion } from "./useAccordion";

const props = withDefaults(defineProps<AccordionProps>(), {
  openItems: () => [],
  multiple: false,
  group: false,
});

const { classes } = useAccordion({ props });
</script>

<template>
  <div part="base" :class="classes">
    <slot />
  </div>
</template>

<style>
:host {
  display: contents;
}
</style>
